import { render, staticRenderFns } from "./BeautyIssuesReported.vue?vue&type=template&id=7ab044ae&scoped=true"
import script from "./BeautyIssuesReported.vue?vue&type=script&lang=js"
export * from "./BeautyIssuesReported.vue?vue&type=script&lang=js"
import style0 from "./BeautyIssuesReported.vue?vue&type=style&index=0&id=7ab044ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab044ae",
  null
  
)

export default component.exports